import { Expose, Transform, Type } from 'class-transformer';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';
import { ICanBeHistoricized } from '../../../shared/data-types/historic-types';

export class ProjectExpenditureEntryModel {
  public id? = null;
  @Expose({ name: 'member_id' })
  public memberId? = null;
  // Task: Expenditure value is either the all-in price or the hourly rate of the task to be invoiced.
  // Assignee: Billable value is the hourly rate of the assignees to be invoiced.
  @Expose({ name: 'expenditure_value' })
  @Type(() => Number)
  public expenditureValue = -1;
  // For new tasks, the negative task id is sent to the server.
  @Expose({ name: 'task_id' })
  public taskId? = null;
  @Expose({ name: 'starting_from' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public startingFrom: Date;
}

// There is a cost rate entry model that is similar to this type, but cost rates are user-specific and always monetary.
// Therefore, cost rates are loaded directly from the backend as CostRateEntryModel, whereas expenditures can be either monetary or in hours
// and consequently need to be transformed first.
export class ExpenditureRateEntry implements ICanBeHistoricized {
  public id: number;
  public startingFrom = new Date();
  public rate: number; // Always monetary.
}
